// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// RelationshipType — source: shared/config/business_classification.config.json § relationship_types

export const RELATIONSHIP_TYPE_VALUES = ["lead", "prospect", "customer", "vendor", "partner", "competitor", "recruitment", "outsourcing", "bank", "employee"] as const;
export type RelationshipType = (typeof RELATIONSHIP_TYPE_VALUES)[number];

export const relationshipTypeUserAssignable: Record<RelationshipType, true | false> = {
  "lead": true,
  "prospect": true,
  "customer": true,
  "vendor": true,
  "partner": true,
  "competitor": true,
  "recruitment": true,
  "outsourcing": true,
  "bank": false,
  "employee": false,
};

